import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

import { getSingleCompanyDetails } from './epics-companies';
import Suspense from '../Common/components/Suspense-component';
import Svgs from '../Common/Svgs';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import localStorage from '../Common/LocalStorage';
import { translations } from '../Common/Translations';

import SingleCompanyDetails from './components/Company-details';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class CompanyDetails extends React.Component {
    getCompanyDetails = () => {
        return getSingleCompanyDetails(this.props.match.params.companyId);
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.companies}</span>
                    </div>

                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-info-circle mr-2" />
                                    {strings.company_info}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.COMPANIES} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <Suspense apiCalls={{ companyDetails: this.getCompanyDetails }}>
                            <SingleCompanyDetails />
                        </Suspense>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CompanyDetails);



// WEBPACK FOOTER //
// ./src/customModules/Companies/component-details-company.js